import { ContactConfig } from '../../contact.types';

export default {
  links: [
    {
      label: 'Forgot user ID or password',
      routerLink: '/login/forgot-account-info',
    },
    {
      label: 'Full account recovery',
      routerLink: '/login/full-recovery',
    },
  ],
  contactDetails: {
    hours: '8:00 AM - 8:00 PM EST',
    days: 'Monday - Friday',
    phone1: '1-866-288-8912',
  },
  footerText: `
    For Security purposes, HARP-related assistance such as password resets
    or identity proofing must be requested from the <strong>CCSQ Service Center
    </strong> via phone.`,
} as ContactConfig;
